var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20/social/google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M19.2511 10.6951C19.2511 9.97569 19.1915 9.45069 19.0626 8.90625H10.6797V12.1534H15.6003C15.5011 12.9604 14.9654 14.1757 13.7749 14.9923L13.7582 15.101L16.4087 17.1133L16.5924 17.1312C18.2788 15.6048 19.2511 13.359 19.2511 10.6951Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M10.6793 19.25C13.09 19.25 15.1138 18.4722 16.592 17.1305L13.7745 14.9916C13.0206 15.5068 12.0086 15.8666 10.6793 15.8666C8.31822 15.8666 6.31427 14.3402 5.59992 12.2305L5.49522 12.2392L2.73917 14.3295L2.70312 14.4277C4.17136 17.286 7.18723 19.25 10.6793 19.25Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    d: "M5.59916 12.2302C5.41068 11.6858 5.30159 11.1024 5.30159 10.4997C5.30159 9.89686 5.41068 9.31355 5.58925 8.76911L5.58425 8.65316L2.79366 6.5293L2.70236 6.57186C2.09723 7.75798 1.75 9.08995 1.75 10.4997C1.75 11.9094 2.09723 13.2413 2.70236 14.4274L5.59916 12.2302Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    d: "M10.6794 5.13331C12.3559 5.13331 13.4868 5.84303 14.1317 6.43612L16.6516 4.025C15.104 2.61528 13.09 1.75 10.6794 1.75C7.18725 1.75 4.17137 3.71387 2.70312 6.57218L5.59002 8.76944C6.3143 6.65972 8.31825 5.13331 10.6794 5.13331Z",
    fill: "#EB4335"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a4148fd5825a8812e7c3b9ad74ce428e.svg";
export { ForwardRef as ReactComponent };